/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AttendanceMarkRequest
 */
export interface AttendanceMarkRequest {
    /**
     * 
     * @type {string}
     * @memberof AttendanceMarkRequest
     */
    playerId: string;
    /**
     * 
     * @type {boolean}
     * @memberof AttendanceMarkRequest
     */
    present: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AttendanceMarkRequest
     */
    late?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AttendanceMarkRequest
     */
    basePaid: boolean;
    /**
     * 
     * @type {number}
     * @memberof AttendanceMarkRequest
     */
    baseAmountPaid?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof AttendanceMarkRequest
     */
    extraPaid: boolean;
    /**
     * 
     * @type {number}
     * @memberof AttendanceMarkRequest
     */
    extraAmountPaid?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof AttendanceMarkRequest
     */
    paid?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AttendanceMarkRequest
     */
    amountPaid?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AttendanceMarkRequest
     */
    comment?: string | null;
}

/**
 * Check if a given object implements the AttendanceMarkRequest interface.
 */
export function instanceOfAttendanceMarkRequest(value: object): value is AttendanceMarkRequest {
    if (!('playerId' in value) || value['playerId'] === undefined) return false;
    if (!('present' in value) || value['present'] === undefined) return false;
    if (!('basePaid' in value) || value['basePaid'] === undefined) return false;
    if (!('extraPaid' in value) || value['extraPaid'] === undefined) return false;
    return true;
}

export function AttendanceMarkRequestFromJSON(json: any): AttendanceMarkRequest {
    return AttendanceMarkRequestFromJSONTyped(json, false);
}

export function AttendanceMarkRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AttendanceMarkRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'playerId': json['playerId'],
        'present': json['present'],
        'late': json['late'] == null ? undefined : json['late'],
        'basePaid': json['basePaid'],
        'baseAmountPaid': json['baseAmountPaid'] == null ? undefined : json['baseAmountPaid'],
        'extraPaid': json['extraPaid'],
        'extraAmountPaid': json['extraAmountPaid'] == null ? undefined : json['extraAmountPaid'],
        'paid': json['paid'] == null ? undefined : json['paid'],
        'amountPaid': json['amountPaid'] == null ? undefined : json['amountPaid'],
        'comment': json['comment'] == null ? undefined : json['comment'],
    };
}

export function AttendanceMarkRequestToJSON(json: any): AttendanceMarkRequest {
    return AttendanceMarkRequestToJSONTyped(json, false);
}

export function AttendanceMarkRequestToJSONTyped(value?: AttendanceMarkRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'playerId': value['playerId'],
        'present': value['present'],
        'late': value['late'],
        'basePaid': value['basePaid'],
        'baseAmountPaid': value['baseAmountPaid'],
        'extraPaid': value['extraPaid'],
        'extraAmountPaid': value['extraAmountPaid'],
        'paid': value['paid'],
        'amountPaid': value['amountPaid'],
        'comment': value['comment'],
    };
}

